module.exports = __webpack_public_path__ + "img/case7.853bc1ae.png";